// lalang
export default {
  set(name, value){
    const v = JSON.stringify(value);
    localStorage.setItem(name, v);
  },
  get(name){
    const d = localStorage.getItem(name);
    if(!d) return null;
    return JSON.parse(d);
  },
  del(name){
    localStorage.removeItem(name);
  },
  truncate(){
    localStorage.clear();
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/views/Orders/Mixins/lStore.js